import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

import { ReactElement } from 'react';
import { red } from '~/ui/constants/colors';

const CustomCheckbox = (props: CheckboxProps): ReactElement => (
  <Checkbox
    sx={{
      padding: 0,
      marginRight: '8px',
      color: 'black',
      '&.Mui-checked': { color: `${red} !important` },
    }}
    {...props}
  />
);

export default CustomCheckbox;
